@if (hasPastDueInvoice() && visible()) {
  <section class="sanofi-infoBanner sanofi-infoBanner--pastDueInvoices py-3 px-3 my-3 d-flex">
    <cx-icon class="sanofi-infoBanner__warningIcon align-self-start pr-2" [type]="iconTypes.WARNING"/>
    <div class="sanofi-infoBanner__content">
      <h5 class="sanofi-infoBanner__header font-bold">{{ 'makeAPayment.pastDueInvoicesBannerTitle' | cxTranslate }}</h5>
      <p class="w-100 mb-0">
        {{ 'makeAPayment.pastDueInvoicesBannerDescription' | cxTranslate }}
        <a class="c-link" [routerLink]="['/', 'my-account','make-payment']">{{ 'makeAPayment.pastDueInvoicesBannerLinkText' | cxTranslate }}</a>
      </p>
    </div>
    <div class="d-flex lign-self-center flex-fill justify-content-end">
      <button aria-label="close"
              tabindex="0"
              role="button"
              aria-pressed="false"
              class="sanofi-infoBanner__closeIconButton"
              (click)="visible.set(false)"
      >
        <cx-icon class="sanofi-infoBanner__closeIcon" [type]="iconTypes.CLOSE"/>
      </button>
    </div>
  </section>
}
